<template>
  <div class="w-full h-full overflow-y-auto px-2 no-scrollbar">
    <div class="flex flex-col">
      <!-- Collection title skeleton -->
      <div class="text-base font-semibold animate-pulse mt-4">
        <div class="h-5 w-2/3 rounded bg-zinc-200"></div>
      </div>
      
      <!-- Rudiment items skeleton - vertical list -->
      <template v-for="n in count" :key="n">
        <div 
          class="p-1 rounded w-full flex mb-2 bg-gray-200 animate-pulse"
          :class="{ 'mt-2': n === 1 }"
        >
          <div class="p-2 w-full">
            <!-- Image skeleton -->
            <div class="aspect-[16/9] w-full rounded-xl bg-zinc-300"></div>
            
            <!-- Title skeleton -->
            <div class="mt-2 h-4 w-3/4 rounded bg-zinc-300 "></div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script setup>
defineProps({
  count: {
    type: Number,
    default: 6
  }
})
</script>